import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOGIN_SUCCESS } from '../actions/types';

function GoogleOAuthCallback() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const access = params.get('access');
    const refresh = params.get('refresh');

    if (access && refresh) {
      localStorage.setItem('access', access);
      localStorage.setItem('refresh', refresh);
      dispatch({ type: LOGIN_SUCCESS, payload: { access, refresh } });
      navigate('/home');
    }
  }, [location, dispatch, navigate]);

  return <p>Processing login...</p>;
}

export default GoogleOAuthCallback;